import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import {
  AuthState,
  FETCH_USER_DATA,
  FETCH_ROUTE_PERMISSIONS,
  GET_USER,
  LOGIN,
  LOGOUT,
  SET_USER,
  CHECK_LOGGED_IN,
  GET_USER_NAME,
  GET_USER_EMAIL,
  GET_USER_GROUPS
} from './types'
import {
  fetchUserData,
  fetchRoutePermissions,
  checkLoggedIn
} from '@/global/auth/store/actions'
import {
  getUser,
  getUserEmail,
  getUserName,
  getUserGroups
} from '@/global/auth/store/getter'

export default async (): Promise<Module<AuthState, {}>> => {
  const { INITIAL_STATE } = await import('./init')
  const { setUser } = await import('./mutations')
  const { login, logout } = await import('./actions')

  const mutations: MutationTree<AuthState> = {
    [SET_USER]: setUser
  }

  const actions: ActionTree<AuthState, {}> = {
    [LOGIN]: login,
    [LOGOUT]: logout,
    [FETCH_USER_DATA]: fetchUserData,
    [FETCH_ROUTE_PERMISSIONS]: fetchRoutePermissions,
    [CHECK_LOGGED_IN]: checkLoggedIn
  }

  const getters: GetterTree<AuthState, {}> = {
    [GET_USER]: getUser,
    [GET_USER_NAME]: getUserName,
    [GET_USER_EMAIL]: getUserEmail,
    [GET_USER_GROUPS]: getUserGroups
  }

  return {
    namespaced: true,
    state: INITIAL_STATE(),
    mutations,
    getters,
    actions
  }
}
